module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS10.33f79d0f.jpg";